module.exports = __webpack_public_path__ + "static/media/qrIllustration.2b9c4d8c.png";